import { render, staticRenderFns } from "./ResourceCalendarManagement.vue?vue&type=template&id=e578172a&scoped=true"
import script from "./ResourceCalendarManagement.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarManagement.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendarManagement.vue?vue&type=style&index=0&id=e578172a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e578172a",
  null
  
)

export default component.exports